import { render, staticRenderFns } from "./EstimatesOldStatus.vue?vue&type=template&id=415c9ff1&"
import script from "./EstimatesOldStatus.vue?vue&type=script&lang=js&"
export * from "./EstimatesOldStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports